import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CustomerService } from '../components/bussinesspages/user-management/customer-service.service';
import { PlanCardComponent } from '../components/bussinesspages/user-management/plan-card/plan-card.component';
import { ActivatedRoute } from '@angular/router';
import { CUSTOMER_MENU_ITEMS } from '../services/gigsumoService';
import { Location } from '@angular/common';

@Component({
  selector: 'app-upgrade-message',
  standalone: true,
  imports: [CommonModule, NgxDatatableModule, PlanCardComponent],
  templateUrl: './upgrade-message.component.html',
  styleUrls: ['./upgrade-message.component.scss']
})
export class UpgradeMessageComponent {
  @Input() allocationCards: any;
  role:any;
  header: string = '';
  @Input() Page: string
  features: Array<{ text: string }> = [];
  private menuMapping = {
    businessNetworks: {
      header: 'Business Networks',
      features: [
        { text: 'B2B Connections' },
        { text: 'B2B Networks' },
        { text: 'B2B Job Sharing' },
        { text: 'B2B Candidate Sharing' },
        { text: 'B2B Interactions' },
        { text: 'Unlimited Support' },

      ]
    },
    businessContacts: {
      header: 'Business Connect',
      features: [
        { text: 'B2B Connections' },
        { text: 'B2B Networks' },
        { text: 'B2B Job Sharing' },
        { text: 'B2B Candidate Sharing' },
        { text: 'B2B Interactions' },
        { text: 'Unlimited Support' },
      ]
    },
    b2bnetworkListing: {
      header: 'Business Connect',
      features: [
        { text: 'B2B Connections' },
        { text: 'B2B Networks' },
        { text: 'B2B Job Sharing' },
        { text: 'B2B Candidate Sharing' },
        { text: 'B2B Interactions' },
        { text: 'Unlimited Support' },
      ]
    },
    network: {
      header: 'Member Networks',
      features: [
        { text: 'Member Connections' },
        { text: 'Member Networks' },
        { text: 'Member Job Sharing' },
        { text: 'Member Candidate Sharing' },
        { text: 'Member Interactions' },
        { text: 'Unlimited Support' },
      ]
    },
    contacts: {
      header: 'Member Connect',
      features: [
        { text: 'Member Connections' },
        { text: 'Member Networks' },
        { text: 'Member Job Sharing' },
        { text: 'Member Candidate Sharing' },
        { text: 'Member Interactions' },
        { text: 'Unlimited Support' },
      ]
    },membernetworkListing: { // Same structure as contacts
      header: 'Member Connect',
      features: [
        { text: 'Member Connections' },
        { text: 'Member Networks' },
        { text: 'Member Job Sharing' },
        { text: 'Member Candidate Sharing' },
        { text: 'Member Interactions' },
        { text: 'Unlimited Support' },
      ]
    },
    workSpace: {
      header: 'Workspaces',
      features: [
        { text: 'Workspace Connections' },
        { text: 'Workspace Creations' },
        { text: 'Workspace Job Sharing' },
        { text: 'Workspace Candidate Sharing' },
        { text: 'Workspace Interactions' },
      ]
    },
    team: {
      header: 'Workspaces',
      features: [
        { text: 'Workspace Connections' },
        { text: 'Workspace Creations' },
        { text: 'Workspace Job Sharing' },
        { text: 'Workspace Candidate Sharing' },
        { text: 'Workspace Interactions' },
      ]
    },
    analytics: {
      header: 'Analytics',
      features: [
        { text: 'Dashboards' },
        { text: 'Job metrics' },
        { text: 'Candidate metrics' },
      ]
    }
  };

  selectedItem: CUSTOMER_MENU_ITEMS;
  @Input() PLANMAX: number;
  dummyListToShow = [
    { businessName: 'Dummy Business', businessOwner: 'John Doe', businessEmail: 'john@example.com' ,createddate:'03/10/2024',lastactive:'10/10/20204'},
    { businessName: 'Dummy Business', businessOwner: 'Jane Smith', businessEmail: 'jane@example.com',createddate:'03/10/2024',lastactive:'10/10/20204' },
    { businessName: 'Dummy Business', businessOwner: 'Bob Brown', businessEmail: 'bob@example.com',createddate:'03/10/2024',lastactive:'10/10/20204' },
    { businessName: 'Dummy Business', businessOwner: 'kiran Brown', businessEmail: 'kiran@example.com',createddate:'03/10/2024',lastactive:'10/10/20204' },
    { businessName: 'Dummy Business', businessOwner: 'Math Brown', businessEmail: 'math@example.com',createddate:'03/10/2024',lastactive:'10/10/20204' },
  ];
  constructor(
  private customerService: CustomerService,private activatedRoute: ActivatedRoute,private location: Location ) {
    this.activatedRoute.queryParams.subscribe((res) => {
      this.role=res.role;
    });
    const data = this.location.path().split("?")[0];
    if (data) {
      this.selectedItem = data.split("/")[data.split("/").length - 1] as CUSTOMER_MENU_ITEMS;
    }
    this.loadHeader();
    console.log(this.header+"hhhj");
  }
  loadHeader() {
    const menuData = this.menuMapping[this.selectedItem];
    if (menuData) {
      this.header = menuData.header;
      this.features = menuData.features; // Get the features array
    } else {
      this.header = 'Default Header'; // Fallback header
      this.features = []; // Empty features if no match
    }
  }

  upgrade(){
    this.customerService.redirectToUpgrade();
   }
}
